import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-black/60 mt-32" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/brand/logo.jpeg" alt="Je Ke Pictures" className="w-11 h-11 rounded-md object-contain bg-white p-0.5" />
            <div>
              <div className="font-cinzel font-bold tracking-[0.2em]">JE KE PICTURES</div>
              <div className="font-cinzel text-[0.65rem] tracking-[0.3em] text-[color:var(--jk-muted)]">PVT. LTD.</div>
            </div>
          </div>
          <p className="text-[color:var(--jk-muted)] max-w-md text-sm leading-relaxed">
            Committed to premium production values, storytelling excellence, and cinematic craftsmanship rooted in Bhojpuri traditions.
          </p>
        </div>

        <div>
          <div className="font-cinzel tracking-[0.2em] text-xs text-[color:var(--jk-gold)] mb-4">EXPLORE</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/films" className="text-[color:var(--jk-muted)] hover:text-white transition-colors">Films</Link></li>
            <li><Link to="/music" className="text-[color:var(--jk-muted)] hover:text-white transition-colors">Music</Link></li>
            <li><Link to="/news" className="text-[color:var(--jk-muted)] hover:text-white transition-colors">News & Press</Link></li>
            <li><Link to="/about" className="text-[color:var(--jk-muted)] hover:text-white transition-colors">About</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-cinzel tracking-[0.2em] text-xs text-[color:var(--jk-gold)] mb-4">LEGAL</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" className="text-[color:var(--jk-muted)] hover:text-white transition-colors" data-testid="footer-terms">Terms & Conditions</Link></li>
            <li><Link to="/privacy" className="text-[color:var(--jk-muted)] hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/contact" className="text-[color:var(--jk-muted)] hover:text-white transition-colors">Contact</Link></li>
          </ul>
          <div className="flex gap-4 mt-6">
            <a href="mailto:jekepictures@gmail.com" className="text-[color:var(--jk-muted)] hover:text-[color:var(--jk-gold)]" aria-label="Email" data-testid="footer-email"><Mail size={18} /></a>
            <a href="https://youtube.com/@jekepictures" target="_blank" rel="noopener noreferrer" className="text-[color:var(--jk-muted)] hover:text-[color:var(--jk-gold)] transition-colors" aria-label="YouTube" data-testid="footer-youtube"><Youtube size={18} /></a>
            <a href="https://www.instagram.com/jekepictures" target="_blank" rel="noopener noreferrer" className="text-[color:var(--jk-muted)] hover:text-[color:var(--jk-gold)] transition-colors" aria-label="Instagram" data-testid="footer-instagram"><Instagram size={18} /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5 py-6">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-[color:var(--jk-muted)]">
          <div>© {new Date().getFullYear()} Je Ke Pictures Pvt. Ltd. All rights reserved.</div>
          <div className="font-cinzel tracking-[0.3em]">A CINEMATIC HOUSE</div>
        </div>
      </div>
    </footer>
  );
}
